export enum TournamentTabs {
  ActiveTournament,
  ProviderTournaments,
}
